import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from 'auth/AuthProvider';
import { useI18n } from 'core/i18n/I18nProvider';
import { firstAccessiblePath, paths } from 'core/routing/paths';
import { Button } from 'shared/components/Button';

export function ForbiddenPage() {
  const { t } = useI18n();
  const { logout, admin, permissions, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const homePath = firstAccessiblePath(admin || permissions);
  const showHome = isAuthenticated && homePath !== paths.forbidden;

  const leaveSession = async () => {
    try {
      await logout();
    } finally {
      navigate(paths.login, { replace: true });
    }
  };

  return (
    <main className="forbidden-page">
      <p className="brand-mark">{t('appName')}</p>
      <p className="code-403">403</p>
      <h1>{t('forbidden.title')}</h1>
      <p>{t('forbidden.body')}</p>
      <div className="toolbar wrap">
        {showHome ? <Link className="btn btn-secondary" to={homePath}>{t('actions.back')}</Link> : null}
        <Button tone="ghost" onClick={leaveSession}>{t('actions.logout')}</Button>
        <Button onClick={leaveSession}>{t('forbidden.switchAdmin')}</Button>
      </div>
    </main>
  );
}
